/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React, {Component} from 'react';
import classNames from 'classname';
import {connect} from 'react-redux';
import SelectItem from '../selectItem';
import {filterSelection} from '../../../reducers/step';
import RightArrow from '../../../svgs/rightArrow';
import CircleClose from '../../../svgs/circleClose';
import CircleTick from '../../../svgs/circleTick';

class SelectRow extends Component {
  constructor (props) {
    super(props);
    const { skus, keysOfOneList, oneListIndex, selected } = this.props;
    if (skus) {
      this.filterSku = filterSelection(skus, keysOfOneList.map(id => selected[id]), 0, oneListIndex)[oneListIndex];
    }
  }
  componentWillReceiveProps (nextProps) {
    const { pid, open, index, id, skus, keysOfOneList, oneListIndex } = this.props;
    const { isOpen, selected } = nextProps;
    // 如果当前选项状态为thr中的childDescMap的出现属性
    // 且并未选中该显示的属性则直接将打开状态跳转至下一个
    if (Number(pid) && isOpen && selected[pid] !== id) {
      open(index + 1);
    }
    if (skus) {
      this.filterSku = filterSelection(skus, keysOfOneList.map(id => selected[id]), 0, oneListIndex)[oneListIndex];
    }
  }
  /**
   * 渲染普通子选项
   * @return Array
   */
  renderItem () {
    const { child, index, open, selected, id, type } = this.props;
    return child.map((item, i) =>
      <SelectItem key={i} open={open} index={index} type={type}
                  disabled={this.filterSku && !this.filterSku.includes(item.id)}
                  selected={selected[id] === item.id} {...item} />
    )
  }
  /**
   * 渲染单多复选选项
   * @return Array
   */
  renderElects () {
    let index = 0;
    const { child, selected, type } = this.props;
    return child.reduce((prev, action) => {
      const child = action.child.map(item =>
        <SelectItem key={index++} parent={action} type={type}
                    selected={selected[action.id] === item.id} {...item} />
      );
      return prev.concat(child);
    }, [])
  }
  render (){
    const { name, selected, isOpen, child, pid, isElects, len, open, index, id, type, names } = this.props;
    const mainHeight = Math.ceil((isElects ? len : child.length) / 5) * 118;
    return <div className={classNames('mcycle-step-select-row', {
      'close': !isOpen,
      'hidden': Number(pid) && selected[pid] !== id
    })}>
      <div className="mcycle-step-select-header" onClick={() => open(index)}>
        <div className="mcycle-step-select-icon">
          {selected[id]
            ? <CircleTick />
            : selected[id] === null
              ? <CircleClose/>
              : null
          }
        </div>
        <div className="mcycle-step-select-title">{name}</div>
        <div className="mcycle-step-select-selected">
          <div className="mcycle-step-select-names">
            {type === 'multi' ? Object.values(names).join('，') : names[id]}
          </div>
        </div>
        <div className="mcycle-step-select-arrow">
          <RightArrow />
        </div>
      </div>
      <div className="mcycle-step-select-main" style={{ height: mainHeight }}>
        {isElects ? this.renderElects() : this.renderItem()}
      </div>
    </div>;
  }
}

export default connect(
  (state, ownProps) => ({
    selected: state.step.selected[ownProps.type],
    names: state.step.selected[`${ownProps.type}Names`]
  })
)(SelectRow);



// WEBPACK FOOTER //
// ./src/components/step1/selectRow/index.js